import { isDev } from "@/config";

// 定义平台类型（约束取值范围，避免魔法字符串）
export type PlatformType = 'electron' | 'android' | 'browser';

// 存储当前平台（全局唯一）

/**
 * 初始化平台判断（项目启动时调用一次即可）
 * @returns 当前检测到的平台
 */
export const getPlatform = (): PlatformType => {
    // 开发环境强制设为browser
    console.log(isDev,'isDev');
    if (isDev) {
        console.log('当前为开发环境，已设置平台为 browser');
        return 'browser';
    }

    const isElectronEnv =
        typeof window !== 'undefined' &&
        (!!(window as any).electronIpc || // 优先通过IPC对象判断
            !!(window as any).require ||
            (navigator.userAgent.includes('Electron')));

    // 安卓Capacitor环境判断（增加安全校验）
    const isAndroidEnv =
        typeof window !== 'undefined' &&
        !!(window as any).Capacitor &&
        (navigator.userAgent.includes('Android') || navigator.userAgent.includes('Capacitor'));

    // 赋值并日志提示
    if (isElectronEnv) {
        console.log('检测到 Electron 环境，已设置平台为 electron');
        return 'electron';
    } else if (isAndroidEnv) {
        console.log('检测到 安卓 Capacitor 环境，已设置平台为 android');
        return 'android';
    } else {
        console.log('检测到 浏览器 环境，已设置平台为 browser');
        return 'browser';
    }

};

